import React from "react";
import { useTranslation } from "react-i18next";
//This hook translates any entity that has a translation map
//The original title key targets the title, name or other fields in an entity that are there if no translation is added
export default function useEntityTranslation(entity, originalTitle = "title") {
  const { i18n } = useTranslation();
  const currentLang = i18n.language;
  const [serviceName, setName] = React.useState(entity?.[originalTitle]);

  React.useEffect(() => {
    const currentLangName = entity?.translations[currentLang];
    if (currentLangName != null && currentLangName != "") {
      setName(currentLangName);
    } else {
      setName(entity?.[originalTitle]);
    }
  }, [currentLang,entity]);

  return serviceName;
}
